import React from 'react';

import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { IIntlMessage } from '../_core/IntlMsg/intl-msg.types';
import { IContactLink } from './report-card-access.types';
import { useReportCardActionsStyles } from './report-card-actions.styles';

interface IReportCardContactLinksMenuProps {
  id: string;
  triggerId: string;
  title: IIntlMessage;
  anchorEl: HTMLElement | null;
  contactLinks: IContactLink[];
  menuListProps: { onMouseEnter: () => void; onMouseLeave: () => void };
  onCopy: (contactLink: IContactLink) => void;
  onClose: () => void;
}

export const ReportCardContactLinksMenu: React.FC<IReportCardContactLinksMenuProps> = ({
  id,
  triggerId,
  title,
  anchorEl,
  contactLinks,
  menuListProps,
  onCopy,
  onClose,
}) => {
  const classes = useReportCardActionsStyles();

  return (
    <Menu
      id={id}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      className={classes.contactSubmenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      elevation={12}
      getContentAnchorEl={null}
      MenuListProps={{ ...menuListProps, role: 'menu', 'aria-labelledby': triggerId }}
    >
      <div className={classes.menuHeader}>
        <Typography variant="caption"><IntlMsg {...title} /></Typography>
      </div>
      {contactLinks.map((contactLink, index) => (
        <MenuItem
          key={contactLink.contact._id || `${contactLink.contact.email}-${index}`}
          onClick={() => onCopy(contactLink)}
          className={classes.menuItem}
          role="menuitem"
        >
          <ListItemText
            primary={contactLink.contact.name}
            secondary={contactLink.contact.email}
            primaryTypographyProps={{ variant: 'body2' }}
            secondaryTypographyProps={{ variant: 'caption' }}
          />
        </MenuItem>
      ))}
    </Menu>
  );
};
